import { useMutation } from 'react-relay';
import { GraphQLTaggedNode, MutationParameters, PayloadError } from 'relay-runtime';
import { useState } from 'react';

type UpdateValuesType = { [key: string]: { [key: string]: string } };

export const useCommitFromMutation = (
    mutation?: GraphQLTaggedNode | null,
) => {
    const [statusUpdate, setStatusUpdate] = useState<'success' | 'failed' | 'none'>('none');

    const [commitUpdate, isInFlightUpdate] = mutation ? useMutation(mutation) : [];

    const commit = (values: UpdateValuesType): MutationParameters => {
        return {
            variables: {
                input: {
                    sheets: Object.keys(values).map((key) => ({
                        sheetId: key,
                        ...values[key],
                    })),
                },
            },
            onCompleted: (response: any, errors: PayloadError[]) => {
                if (errors) {
                    console.log(
                        (
                            errors[0] as PayloadError & {
                                extensions: { debugMessage: string };
                            }
                        ).extensions.debugMessage,
                        errors,
                    );
                } else {
                    setStatusUpdate('success');

                    setTimeout(() => {
                        setStatusUpdate('none');
                    }, 500);

                    console.log('Update successful', response);
                }
            },
            onError: (error: any) => {
                setStatusUpdate('failed');
                console.error('Mutation error:', error);
            },
        } as unknown as MutationParameters;
    };

    const updateCommit = (values: UpdateValuesType) => {
        commitUpdate?.(commit(values));
    };

    return { updateCommit, isInFlightUpdate, statusUpdate };
};
